import { render } from "./PaymentSection.vue?vue&type=template&id=1f62cf87"
import script from "./PaymentSection.vue?vue&type=script&lang=js"
export * from "./PaymentSection.vue?vue&type=script&lang=js"

import "./PaymentSection.vue?vue&type=style&index=0&id=1f62cf87&lang=css"

import exportComponent from "D:\\VueJs project\\product\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__